module.exports = __webpack_public_path__ + "img/check_icon.6e97fd74.png";